import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { request } from '../api';
import Layout from '../components/Layout';
import Prompt from '../components/Prompt';
export default function PublicPrompt() {
  const [params] = useSearchParams(),
    [text, setText] = useState(''),
    [error, setError] = useState('');
  const batch = params.get('batch'),
    horizon = params.get('horizon') || '1d';
  useEffect(() => {
    let live = true;
    request(batch ? `/batches/${batch}/prompt` : `/prompt-template?horizon=${horizon}`).then(d => live && setText(d.prompt)).catch(e => live && setError(e.message));
    return () => {
      live = false;
    };
  }, [batch, horizon]);
  return <Layout title="Public stock-selection prompt" error={error}><p>Anyone can copy the standardized prompt. A template is illustrative; recording model responses requires a server-issued batch.</p><Prompt text={text} /></Layout>;
}
